import _objectSpread from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createSuper";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.splice.js";
import Gikam from 'gikam';
import tree from './vue/tree.vue';
import Vue from 'vue';
import Base from '../base';
import jQuery from 'jquery';
import { I18N } from '@/gikam/i18n/I18N.js';
var defaultOptions = {
  renderTo: void 0,
  //树的名称
  name: void 0,
  url: void 0,
  rootId: 'root',
  selectedNodeData: null,
  selectedNode: null,
  cascadeCheck: true,
  // 是否级联勾选父子节点
  data: [],
  // 新增删除时使用
  baseUrl: null,
  // 节点名称对应的字段
  nodeTextField: null,
  // 是否可以编辑
  edit: false,
  // 树的加载是否是异步,如果是异步点击节点时，才加载子节点
  async: true,
  // 树是否是有多选框
  checkbox: false,
  // 点击节点名称是否勾选复选框
  checkOnActive: false,
  requestData: {},
  // 是否可以拖放
  draggable: false,
  // 点击加减号才能收缩树节点
  expandOnTextClick: true,
  // 节点展开和收缩节点,参数node
  onNodeToggle: null,
  // 节点复选框勾选事件
  onNodeChecked: null,
  // 节点样式格式化方法，参数为节点数据
  nodeStyleFormatter: null
};

var Tree = /*#__PURE__*/function (_Base) {
  _inherits(Tree, _Base);

  var _super = _createSuper(Tree);

  function Tree(options) {
    var _this2;

    _classCallCheck(this, Tree);

    _this2 = _super.call(this, 'Tree');
    _this2.listeners = {
      nodeSelected: Gikam.emptyFunction,
      beforeRequest: Gikam.emptyFunction,
      beforeDelete: Gikam.emptyFunction,
      // 触发拖拽完成之后的事件
      afterDrop: Gikam.emptyFunction,
      //加载成功之后的事件
      loadSuccess: Gikam.emptyFunction,
      //编辑结之后的事件
      afterEdit: Gikam.emptyFunction,
      //保存之前的事件
      beforeSave: Gikam.emptyFunction,
      // 删除树节点之后的事件
      afterDelete: Gikam.emptyFunction
    };
    _this2.requesting = false;
    _this2.loadSuccessCallback = [];

    _this2.initialize(options, defaultOptions).init();

    return _this2;
  }

  _createClass(Tree, [{
    key: "init",
    value: function init() {
      this.model = this.createModel();
      this.bindInstance(this.model.$el);
      this.renderTree();
      this.bindEvent();
    }
  }, {
    key: "createModel",
    value: function createModel() {
      var h = this.$createElement;

      var _this = this;

      return new Vue({
        el: Gikam.createDom('div', this.options.renderTo),
        components: {
          tree: tree
        },
        provide: {
          tree: this
        },
        data: function data() {
          return {
            options: _this.options,
            treeStringId: ''
          };
        },
        render: function render() {
          var h = arguments[0];
          return h(tree, {
            "attrs": {
              "options": this.options
            },
            "on": {
              "headClick": function headClick() {
                _this.trigger('nodeSelected', null, {
                  id: null
                });

                var selectedNode = _this.options.selectedNode;
                selectedNode && selectedNode.classList.remove('selected');
                _this.options.selectedNode = null;
                _this.options.selectedNodeData = null;
              }
            }
          });
        }
      });
    }
  }, {
    key: "getData",
    value: function getData(parentId) {
      var _this3 = this;

      var def = jQuery.Deferred();

      if (!this.options.url) {
        if (!parentId) return def.resolve(this.options.data);
        return def.resolve([]);
      }

      var url = this.options.url;

      if (this.options.async === true) {
        url = Gikam.printf(url, {
          parentId: parentId || this.options.rootId
        });
      }

      var requestData;

      if (this.options.requestData) {
        requestData = Gikam.getJsonWrapper({
          f: this.options.requestData
        });
      }

      this.requesting = true;
      Gikam.postText(url, requestData).done(function (rows) {
        if (rows) {
          def.resolve(JSON.parse(rows));
        } else {
          def.resolve([]);
        }
      }).always(function () {
        _this3.requesting = false;
      });
      return def;
    }
  }, {
    key: "renderTree",
    value: function renderTree() {
      var _this = this;

      this.getData().done(function (list) {
        _this.options.data = list;

        _this.model.$nextTick(function () {
          _this.loadSuccessCallback.forEach(function (item) {
            item.call(_this, list);
          });

          _this.loadSuccessCallback.length = 0;
          _this.options.selectedNodeData = null;

          _this.trigger('loadSuccess', list);
        });
      });
    }
  }, {
    key: "refresh",
    value: function refresh(param) {
      this.editing = false;

      if (param) {
        Gikam.extend(true, this.options, param);
      }

      this.model.$children[0].$refs.rootNode.expandes = [];
      this.renderTree();
    }
  }, {
    key: "getSelectedNodeId",
    value: function getSelectedNodeId() {
      return this.options.selectedNodeData ? this.options.selectedNodeData.id : null;
    }
  }, {
    key: "getSelectedNode",
    value: function getSelectedNode() {
      var node = {};
      var selectedNodeData = this.options.selectedNodeData;

      if (!selectedNodeData) {
        return null;
      }

      Object.keys(selectedNodeData).forEach(function (key) {
        if (key === 'children') {
          return;
        }

        node[key] = selectedNodeData[key];
      });
      var nodeId = selectedNodeData.id,
          nodeText = selectedNodeData.text,
          childQty = selectedNodeData.childQty;
      return _objectSpread(_objectSpread({}, node), {
        nodeId: nodeId,
        nodeText: nodeText,
        childQty: childQty
      });
    }
  }, {
    key: "getSelections",
    value: function getSelections() {
      return Gikam.filterTree(this.options.data, function (item) {
        return item.checked;
      }, false);
    }
  }, {
    key: "deleteNode",
    value: function deleteNode(node, array) {
      if (!array) {
        array = this.options.data;
      }

      var _this = this;

      var result = false;
      Gikam.each(array, function (i) {
        if (node === this) {
          array.splice(i, 1);
          result = true;
          return false;
        }

        if (Gikam.isNotEmpty(this.children)) {
          if (_this.deleteNode(node, this.children)) {
            result = true;
            return false;
          }
        }
      });
      return result;
    }
  }, {
    key: "bindEvent",
    value: function bindEvent() {
      var _this = this;

      jQuery(this.model.$el).on('mouseenter', '.tree-header', function (e) {
        if (_this.options.edit === false) {
          return;
        }

        jQuery(e.currentTarget).addClass('hover');
      });
      jQuery(this.model.$el).on('mouseleave', '.tree-header', function (e) {
        if (_this.options.edit === false) {
          return;
        }

        jQuery(e.currentTarget).removeClass('hover');
      });
      jQuery(this.model.$el).on('click', '.tree-header>.insert-btn', function () {
        if (_this.options.edit === false) {
          return;
        }

        var newNode = {
          text: I18N.prop('tree.newNode'),
          id: null,
          parentId: '',
          editable: true
        };

        _this.options.data.push(newNode);

        _this.editing = true;
      });
    }
  }, {
    key: "onLoadSuccess",
    value: function onLoadSuccess(callback) {
      if (this.requesting) {
        this.loadSuccessCallback.push(callback);
      } else {
        callback.call(this, this.options.data);
      }
    }
  }, {
    key: "selectNodeById",
    value: function selectNodeById(id) {
      var liNode = document.querySelector('#' + this.options.id + '-' + id);
      liNode && liNode.querySelector('.node-text').click();
    }
    /**
     * @description 刷新指定节点，如果nodeId为空，则刷新整棵树
     * @public
     * @param {String,Number} nodeId 要刷新的节点id
     * @returns Tree
     * @memberof Tree
     */

  }, {
    key: "refreshNode",
    value: function refreshNode(nodeId) {
      var _this4 = this;

      if (Gikam.isEmpty(nodeId)) {
        this.refresh();
      } else {
        this.getData(nodeId).done(function (childrenNodes) {
          var node = _this4.getNodeById(_this4.options.data, nodeId);

          Vue.set(node, 'childQty', childrenNodes.length);
          Vue.set(node, 'children', childrenNodes);
        });
      }

      return this;
    }
    /**
     * 通过id获取节点
     * @private
     * @param {object} nodes, {String,Number} id
     * @memberof Tree
     */

  }, {
    key: "getNodeById",
    value: function getNodeById(nodes, id) {
      var _this = this;

      var node;
      Gikam.each(nodes, function () {
        if (this.id == id) {
          node = this;
          return false;
        }

        if (Gikam.isNotEmpty(this.children)) {
          node = _this.getNodeById(this.children, id);

          if (node) {
            return false;
          }
        }
      });
      return node;
    } //设置节点的显示名称，用于本地更新，不请求数据

  }, {
    key: "setNodeText",
    value: function setNodeText(nodeId, text) {
      if (Gikam.isEmpty(nodeId)) {
        return;
      }

      this.getNodeById(this.options.data, nodeId).text = text;
    }
    /**
     * 获取树节点数据
     * @public
     * @param
     * @memberof Tree
     */

  }, {
    key: "getTreeList",
    value: function getTreeList() {
      return this.options.data;
    }
    /**
     * 展开树节点
     * @public
     * @param
     * @memberof Tree
     */

  }, {
    key: "setNodeExpand",
    value: function setNodeExpand(nodeId) {
      var _this5 = this;

      var def = Gikam.getDeferred();
      Gikam.eachTree(this.options.data, function (node) {
        if (node.id === nodeId) {
          Vue.set(node, 'expanded', true);

          _this5.model.$nextTick(function () {
            def.resolve();
          });
        }
      });
      return def;
    }
    /**
     * 通过id判断节点是否存在
     * @public
     * @param {string} nodeId需判断的节点id
     * @memberof Tree
     */

  }, {
    key: "nodeExistsById",
    value: function nodeExistsById(nodeId) {
      if (Gikam.isEmpty(nodeId)) {
        return false;
      }

      var node = this.getNodeById(this.options.data, nodeId);
      return Gikam.isEmpty(node) ? true : false;
    }
  }]);

  return Tree;
}(Base);

export { Tree as default };